"use strict";
// (C) 2007-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFilterValueToDateRange = exports.dateRangeToDateFilterValue = void 0;
var DateConversions_1 = require("../utils/DateConversions");
exports.dateRangeToDateFilterValue = function (range, localIdentifier) { return ({
    // GD Platform doesn't support time here
    from: DateConversions_1.convertDateToPlatformDateString(range.from),
    to: DateConversions_1.convertDateToPlatformDateString(range.to),
    localIdentifier: localIdentifier,
    type: "absoluteForm",
    name: "",
    visible: true,
}); };
exports.dateFilterValueToDateRange = function (value) { return ({
    from: value && DateConversions_1.convertPlatformDateStringToDate(value.from),
    to: value && DateConversions_1.convertPlatformDateStringToDate(value.to),
}); };
//# sourceMappingURL=conversions.js.map